import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles, createTheme } from '@material-ui/core/styles';
import { Nav } from 'react-bootstrap';
import * as routes from 'routes';
import { FaUserAlt, FaRegNewspaper } from 'react-icons/fa';
import { FaUserXmark, FaUserCheck, FaUserClock } from 'react-icons/fa6';
import { CgMediaPodcast } from 'react-icons/cg';
import { GiNewspaper } from 'react-icons/gi';
import { ImPodcast } from 'react-icons/im';
import { SiGraphql } from 'react-icons/si';
import Logo from '../../images/Logo.png';

const theme = createTheme();

theme.typography.h3 = {
  fontSize: '1rem !important',
  color: 'rgba(255, 255, 255, .6)',
  fontWeight: '400 !important',
  cursor: 'pointer',
  transition: 'color .2s ease-in-out',
  borderBottom: '1px solid #4b545c',
  textDecoration: 'none',
  padding: '.4rem 1.4rem 1.4rem 1.4rem',

  '&:hover': {
    color: 'rgba(255, 255, 255, .95)',
  },
};

const useStyles = makeStyles({
  root: {
    // background: '#1F1A3C',
    background: '#ffff',
    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 20px',
    // boxShadow: '0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.22)',
    overflowY: 'hidden',
    zIndex: 100,
    height: 'inherit',
    minHeight: '100vh',
    position: 'fixed',
    top: 0,
    width: 'var(--width-sideBar)',
    transition: 'transform .35s ease-in',

    '@media only screen and (max-width: 56.25em)': {
      transform: 'translateX(-25rem)',
    },
  },
  link: {
    textDecoration: 'none',
  },
  logoWrapper: {
    width: '100%',
    height: '100px',
    margin: '14px auto 0',
    textAlign: 'center',
  },
  logo: {
    width: '70%',
    height: 'auto',
  },

  sidebar: {
    height: 'calc(100% - (3.5rem + 1px))',
    overflowY: 'auto',
    padding: '0 10px',
    color: 'white',
  },

  icon: {
    fontSize: '.8rem',
    marginLeft: '.6rem',
  },

  active: {
    transform: 'translateX(0)',
  },
  sidebarHeading: {
    fontSize: '27px !important',
    textAlign: 'right',
    fontWeight: 'bold !important',
    color: 'white',
    marginTop: '-15px',
  },
  navbarIcon: {
    width: '50px',
    display: 'flex',
    justifyContent: 'center',
  },
  navItem: {
    padding: '1px 0',
  },
  brandName: {
    textAlign: 'center',
    marginTop: '30px',
    fontSize: '26px',
  },
  activeNavLink: {
    color: '#fff !important',
    background: '#45b77c',
    display: 'flex',
    alignItems: 'center',
  },
  navLink: {
    color: 'black !important',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
  },
});

const SideBar = () => {
  const loginType = +localStorage.getItem('loginType');
  const classes = useStyles();
  const history = useHistory();

  const [activePath] = useState(window.location.pathname);
  const sideBarStatus = useSelector(state => state.sideBar);

  const handleClick = (e, path) => {
    history.push(path);
    e.stopPropagation();
  };
  const getUsersMenu = () => {
    return (
      <>
        <Nav.Item className={classes.navItem}>
          <Nav.Link
            onClick={e => handleClick(e, routes.USERS)}
            className={
              activePath === routes.USERS
                ? classes.activeNavLink
                : classes.navLink
            }
            active={activePath === routes.USERS ? true : false}
          >
            <div className={classes.navbarIcon}>
              <FaUserAlt
                fill={activePath === routes.USERS ? 'white' : 'black'}
              />
            </div>
            Users
          </Nav.Link>
        </Nav.Item>
      </>
    );
  };
  const getVerifyNewsMenu = () => {
    return (
      <>
        <Nav.Item className={classes.navItem}>
          <Nav.Link
            onClick={e => handleClick(e, routes.VERIFY_NEWS)}
            className={
              activePath === routes.VERIFY_NEWS
                ? classes.activeNavLink
                : classes.navLink
            }
            active={activePath === routes.VERIFY_NEWS ? true : false}
          >
            <div className={classes.navbarIcon}>
              <FaRegNewspaper
                fill={activePath === routes.VERIFY_NEWS ? '#fff' : 'black'}
              />
            </div>
            Verify News
          </Nav.Link>
        </Nav.Item>
      </>
    );
  };
  const getVerifyPodcastMenu = () => {
    return (
      <>
        <Nav.Item className={classes.navItem}>
          <Nav.Link
            onClick={e => handleClick(e, routes.VERIFY_PODCAST)}
            className={
              activePath === routes.VERIFY_PODCAST
                ? classes.activeNavLink
                : classes.navLink
            }
            active={activePath === routes.VERIFY_PODCAST ? true : false}
          >
            <div className={classes.navbarIcon}>
              <ImPodcast
                fill={activePath === routes.VERIFY_PODCAST ? '#fff' : 'black'}
              />
            </div>
            Verify Podcast
          </Nav.Link>
        </Nav.Item>
      </>
    );
  };
  const getStatisticsMenu = () => {
    return (
      <>
        <Nav.Item className={classes.navItem}>
          <Nav.Link
            className={
              activePath === routes.STATISTICS
                ? classes.activeNavLink
                : classes.navLink
            }
            onClick={e => handleClick(e, routes.STATISTICS)}
            active={activePath === routes.STATISTICS ? true : false}
          >
            <div className={classes.navbarIcon}>
              <SiGraphql
                fill={activePath === routes.STATISTICS ? '#fff' : 'black'}
              />
            </div>
            Statistics
          </Nav.Link>
        </Nav.Item>
      </>
    );
  };
  const getVerifiedUserMenu = () => {
    return (
      <>
        <Nav.Item className={classes.navItem}>
          <Nav.Link
            className={
              activePath === routes.VERIFIED_USER
                ? classes.activeNavLink
                : classes.navLink
            }
            onClick={e => handleClick(e, routes.VERIFIED_USER)}
            active={activePath === routes.VERIFIED_USER ? true : false}
          >
            <div className={classes.navbarIcon}>
              <FaUserCheck
                fill={activePath === routes.VERIFIED_USER ? '#fff' : 'black'}
              />
            </div>
            Verified User
          </Nav.Link>
        </Nav.Item>
      </>
    );
  };
  const getUnverifiedUserMenu = () => {
    return (
      <>
        <Nav.Item className={classes.navItem}>
          <Nav.Link
            className={
              activePath === routes.UNVERIFIED_USER
                ? classes.activeNavLink
                : classes.navLink
            }
            onClick={e => handleClick(e, routes.UNVERIFIED_USER)}
            active={activePath === routes.UNVERIFIED_USER ? true : false}
          >
            <div className={classes.navbarIcon}>
              <FaUserXmark
                fill={activePath === routes.UNVERIFIED_USER ? '#fff' : 'black'}
              />
            </div>
            Unverified User
          </Nav.Link>
        </Nav.Item>
      </>
    );
  };
  const getPendingUserMenu = () => {
    return (
      <>
        <Nav.Item className={classes.navItem}>
          <Nav.Link
            className={
              activePath === routes.PENDING_USER
                ? classes.activeNavLink
                : classes.navLink
            }
            onClick={e => handleClick(e, routes.PENDING_USER)}
            active={activePath === routes.PENDING_USER ? true : false}
          >
            <div className={classes.navbarIcon}>
              <FaUserClock
                fill={activePath === routes.PENDING_USER ? '#fff' : 'black'}
              />
            </div>
            Pending User
          </Nav.Link>
        </Nav.Item>
      </>
    );
  };
  const getSidebarMeuns = (val, type) => {
    if (val === 1) {
      switch (type) {
        case 'USERS':
          return getUsersMenu();
        case 'VERIFY_NEWS':
          return getVerifyNewsMenu();
        case 'VERIFY_PODCAST':
          return getVerifyPodcastMenu();
        case 'STATISTICS':
          return getStatisticsMenu();
        case 'VERIFIED_USER':
          return getVerifiedUserMenu();
        case 'UNVERIFIED_USER':
          return getUnverifiedUserMenu();
        case 'PENDING_USER':
          return getPendingUserMenu();
        default:
          break;
      }
    }
  };

  return (
    <aside className={`${classes.root} ${sideBarStatus ? classes.active : ''}`}>
      <div className={classes.logoWrapper} >
        <img src={Logo} alt="Logo" className={classes.logo} />
      </div>
      <div className={classes.sidebar}>
        {getSidebarMeuns(loginType, 'STATISTICS')}
        {getSidebarMeuns(loginType, 'USERS')}
        <Nav.Item className={classes.navItem}>
          <Nav.Link
            onClick={e => handleClick(e, routes.NEWS)}
            className={
              activePath === routes.NEWS
                ? classes.activeNavLink
                : classes.navLink
            }
            active={activePath === routes.NEWS ? true : false}
          >
            <div className={classes.navbarIcon}>
              <GiNewspaper
                fill={activePath === routes.NEWS ? '#fff' : 'black'}
              />
            </div>
            News
          </Nav.Link>
        </Nav.Item>
        {getSidebarMeuns(loginType, 'VERIFY_NEWS')}
        <Nav.Item className={classes.navItem}>
          <Nav.Link
            onClick={e => handleClick(e, routes.ADD_PODCAST)}
            className={
              activePath === routes.ADD_PODCAST
                ? classes.activeNavLink
                : classes.navLink
            }
            active={activePath === routes.ADD_PODCAST ? true : false}
          >
            <div className={classes.navbarIcon}>
              <CgMediaPodcast
                fill={activePath === routes.ADD_PODCAST ? '#fff' : 'black'}
              />
            </div>
            Podcast
          </Nav.Link>
        </Nav.Item>
        {getSidebarMeuns(loginType, 'VERIFY_PODCAST')}
        {getSidebarMeuns(loginType, 'VERIFIED_USER')}
        {getSidebarMeuns(loginType, 'UNVERIFIED_USER')}
        {getSidebarMeuns(loginType, 'PENDING_USER')}
      </div>
    </aside>
  );
};

export default SideBar;
